import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/internal/Subscription';
import { MessService } from 'src/app/_services/mess-service.service';
import { ProductTypesService } from 'src/app/_services/product-types.service';

@Component({
  selector: 'app-product-types-add',
  templateUrl: './product-types-add.component.html',
  styleUrls: ['./product-types-add.component.scss'],
})
export class ProductTypesAddComponent implements OnInit {
  addProductTypeForm: FormArray;
  disableSave: boolean = true;

  subscriptions: Subscription[] = [];

  constructor(
    private fb: FormBuilder,
    private productTypesService: ProductTypesService,
    private messService: MessService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  // * Lifecycles === //
  ngOnInit(): void {
    this.addProductTypeForm = this.fb.array([
      this.fb.group({
        name: ['', Validators.required],
      }),
    ]);
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    this.messService.clearErrors();
  }

  // * Helpers === //
  createProductType(): FormGroup {
    return this.fb.group({
      name: ['', Validators.required],
    });
  }

  getControls() {
    return (<FormArray>this.addProductTypeForm).controls;
  }

  addProductType(): void {
    this.addProductTypeForm.push(this.createProductType());
  }

  removeProductType(productTypeId: number): void {
    this.addProductTypeForm.removeAt(productTypeId);
  }

  // * Add product === //
  onAddProductType() {
    let productTypes = this.addProductTypeForm.getRawValue();
    this.subscriptions.push(
      this.productTypesService.addProductType(productTypes).subscribe(
        () => {
          this.messService.add({
            severity: 'success',
            title: 'Uspešno kreiranje',
            detail: 'Kreirali ste novi tip.',
          });
          this.router.navigate(['./../'], { relativeTo: this.route });
        },
        (error) => {
          const errorObj = error.error.errors;
          const indexOfInvalidField = error.error.item - 1;
          const form = this.getControls()[indexOfInvalidField];
          const messService = this.messService;
          Object.keys(errorObj).forEach(function (key) {
            const formControl = form.get(key);
            if (formControl) {
              // If error exist set red border to field
              formControl.setErrors({});
            }
            // Push toast error for every field
            messService.addError({
              severity: 'error',
              title: 'Greška',
              detail: errorObj[key],
              sticky: true,
            });
          });
        }
      )
    );
  }
}
